<template>
    <div class="profile_page">
        <div class="setting_form" v-if="setting">
            <div class="item clearfix">
                <div class="label f-l label-setting-notification">メール配信</div>
                <div class="input f-r">
                    <el-switch v-model="setting.is_notification_new_message"
                        @change="change"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {mapActions} from 'vuex'
  import ProfileApi from '@/api/profile'

  export default {
    name: 'profile',
    data () {
      return {
        setting: null
      }
    },
    methods: {
      ...mapActions({
        setNavigatorLinks: 'navigator/setLinks',
        setNavigatorTitle: 'navigator/setTitle'
      }),
      async fetchSetting () {
        const res = await ProfileApi.get()
        this.setting = res.data.data
      },
      change () {
        ProfileApi.store(this.setting)
      }
    },
    mounted () {
      this.setNavigatorLinks([])
      this.setNavigatorTitle('設定')
      this.fetchSetting()
    }
  }
</script>

<style scoped lang="scss">
    .setting_form {
        .item {
            padding: 20px;
            .label {
                font-size: 14px;
                font-weight: bold;
                color: #0068b6;
            }
        }
        .save-setting-btn {
            position: fixed;
            top: 20px;
            color: #fff;
            z-index: 21;
            right: 20px;
            text-decoration: none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/screens/profile/index.vue